import { LocalizedDateFromUtc, TooltippedHighlightIcon } from '@mews-commander/ui';
import { UnicodeEntity } from '@mews/enums';
import { IconName, Stack, Typography } from '@optimus-web/core';
import { lt } from '@mews/framework';
import { useExpirationDaysLeftCount } from '../hooks/useExpirationDaysLeftCount';

const ExpirationDateIcon = ({ expirationDate }: { expirationDate: string }) => {
    const expirationDaysLeftCount = useExpirationDaysLeftCount(expirationDate);

    if (expirationDaysLeftCount === null) {
        return null;
    }

    if (expirationDaysLeftCount < 0) {
        return (
            <TooltippedHighlightIcon
                value={IconName.AlertCircle}
                size="small"
                iconVariant="basic"
                tooltip={lt('ContractDocumentExpiredTooltip')}
            />
        );
    }

    return null;
};

export const ExpirationDate = ({ expirationDate }: { expirationDate?: string }) => (
    <Typography textStyle="bodyMedium" as="div">
        {expirationDate != null ? (
            <Stack itemAlignment="center" spacing="50">
                <ExpirationDateIcon expirationDate={expirationDate} />
                <LocalizedDateFromUtc utcString={expirationDate} />
            </Stack>
        ) : (
            UnicodeEntity.Dash
        )}
    </Typography>
);
